import { createFileRoute, redirect } from '@tanstack/react-router';

import { CONFIG } from 'src/global-config';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Redirect to dashboard (or configured redirect path)
    throw redirect({
      to: CONFIG.auth.redirectPath,
    });
  },
});
